import { css } from 'styled-components';

export const wrapper = css`
  width: 800px;
  margin: 2rem auto 0;

  @media (max-width: 1024px) {
    width: 750px;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

export const customStepper = css`
  display: flex;
  padding: 0;
`;

export const customStepperTitle = css`
  color: #cccccc;
  font-family: 'VodafoneRegular';
  font-size: 20px;
  margin-bottom: 0.5rem;

  @media (max-width: 767px) {
    font-size: 16px;
  }
`;

export const customStepperTitleActive = css`
  color: #333333;
  font-weight: bold;
  font-size: 20px;

  @media (max-width: 767px) {
    font-size: 16px;
  }
`;

export const customStepperItem = css`
  display: flex;
  flex-direction: column;
  flex: 1;
  text-align: center;
  &:before {
    --size: 3rem;
    width: clamp(1rem, 2vw, 1.2rem);
    height: clamp(1rem, 2vw, 1.2rem);
    content: '';
    display: block;
    border-radius: 50%;
    background-color: #cccccc;
    margin: 0 auto 0.5rem;
  }
`;

export const customStepperItemActive = css`
  &:before {
    background-color: #e60000;
    border: 2px solid #fff;
    box-shadow: 0 0 0 2px #e60000;
    z-index: 2;
    margin: -2px auto 0.4rem;
  }
`;

export const customStepperItemAfter = css`
    &:not(:last-child):after{
        content: "";
        position: relative;
        top: calc(clamp(1rem, 2vw, 1.2rem) / 2);
        width: calc(100% - clamp(1rem, 2vw, 1.2rem) - calc(clamp(0rem, 2vw, 0rem)) * 2));
        left: calc(50% + calc(clamp(1rem, 2vw, 1.2rem) / 2 + clamp(0rem, 2vw, 0rem)));
        height: 2px;
        background-color: #CCCCCC;
        order: -1;
    }
`;

export const customStepperItemLineActive = css`
  &:not(:last-child):after {
    background-color: #e60000;
  }
`;
